import { render, staticRenderFns } from "./TaxpayerInfoForm.vue?vue&type=template&id=88f8572a&"
import script from "./TaxpayerInfoForm.vue?vue&type=script&lang=ts&"
export * from "./TaxpayerInfoForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports